module.exports = __webpack_public_path__ + "a42c2f49ed4752375b749bb844a5fd33.png";